import { useCreateEditSurveyMutation } from "../../../../../api/surveys/useCreateEditSurveyMutation";
import { SETTINGS_ROUTES } from "../../../../../consts/routes";
import { history } from "../../../../../history";
import { useAppTranslation } from "../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../services/UINotificationService";
import { extractApiError } from "../../../../../utilities/api";
import {
  blockAdapter,
  getPathParams,
  questionNamesValid,
  questionsChoicesValid,
  questionsLengthValid,
  titleValid,
} from "../utilities";

export const useSubmit = () => {
  const { surveyId, isEditMode } = getPathParams();

  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const { mutateAsync, isLoading } = useCreateEditSurveyMutation({
    onSuccess: () => {
      if (isEditMode) {
        uiNotification.success(t("success.update"));
      } else {
        uiNotification.success(t("success.create"));
      }
      history.push(SETTINGS_ROUTES.surveys() + "?skipPrompt=true");
    },
    onError: (res) => {
      const message = extractApiError(res);
      if (isEditMode) {
        uiNotification.error(t([`error.${message}`, "error.update"]));
      } else {
        uiNotification.error(t([`error.${message}`, "error.create"]));
      }
    },
  });

  return {
    initiate: ({ title, questions }) => {
      const questions_ = questions.map((block, index) =>
        blockAdapter.send(block, index + 1, isEditMode),
      );

      var error = [
        titleValid(title),
        questionsLengthValid(questions_),
        questionsChoicesValid(questions_),
        questionNamesValid(questions_),
      ].filter(Boolean)[0];

      if (error) {
        uiNotification.error(t(`error.${error}`));
        return;
      }

      return mutateAsync({
        id: isEditMode ? surveyId : null,
        title,
        questions: questions_,
      });
    },
    isLoading,
  };
};
